import React from 'react';
import './rulesOne.css'

export default function RulesOne({history}) {

    function goToRules2(){
        history.push('/rules2')
    }

    function goToHome(){
        history.push('/home')
    }

    return (
        <div>
            <div onClick={goToHome} className='container-arrow'>
                <i className="left"></i>
                <p className='text-back'>Voltar</p>
            </div>
            <p className='title-page'>Regras</p>
            <p className='text'>
                O teste eneagrama é uma metodologia de autoconhecimento comprovadamente eficaz, sendo um teste longo e profundo composto por 135 perguntas.
                </p>
            <p className='text'>
                O seu preenchimento tende a levar entre 30 minutos a 1 hora para ser realizado, separe um tempo do seu dia e faça com calma, caso necessário o teste pode ser interrompido e salvo a qualquer momento e finalizado mais tarde
            </p>
            
            <button className="continue-btn" onClick={goToRules2}>Continuar</button>
        </div >
    );
}